import { Canvas } from "@react-three/fiber";

import { Model } from "../Model";

const App = () => {
  return (
    <div className="flex h-screen flex-col justify-between lg:flex-row">
      <div className="grow pt-8 lg:bg-white">
        <h1 className="text-center text-2xl">Dan Page</h1>
        <div className="m-4 rounded-lg bg-white p-4">
          <h1>Deliveroo</h1>
          <h2>Software Engineer</h2>
        </div>
      </div>

      <div className="h-2/3 lg:h-full lg:w-3/5">
        <Canvas camera={{ position: [0, 2, 3] }}>
          {/* <OrbitControls rotation={[1, 0, 0]} /> */}
          <ambientLight intensity={0.5} />
          <directionalLight color="white" position={[0, 3, 0]} />
          {/* <Sphere /> */}
          <Model position={[0, 0, 1]} scale={1.1} />
        </Canvas>
      </div>
    </div>
  );
};

export default App;
